<template lang="pug">
el-form(ref='supportAuthForm', label-width='120px', label-position="top", v-loading="loading", v-if="companies.length > 1")
	el-form-item(label="Select the company you would like help with")
		el-select(v-model='companyId' placeholder='Select a company')
			el-option(v-for='company in companies' :key='company.id' :label='company.name' :value='company.id')
	el-form-item
		el-button(type='primary', :loading="loading",:disabled="!this.companyId", @click='visitZendesk') Visit Support
h3(v-else) Authenticating...
</template>

<script>
import gql from "graphql-tag";
import UserCompaniesQuery from "@/graphql/queries/UserCompanies.js";
// import axios from "axios";

export default {
	data: () => ({
		companyId: "",
		companies: [],
		loading: false
	}),
	methods: {
		async visitZendesk() {
			this.loading = true;
			try {
				const token = await this.getToken();
				// console.log("token", token);

				// Clear any active Zendesk sessions first
				// try {
				// 	await axios.get("https://wonde.zendesk.com/access/logout.json", {
				// 		crossdomain: true,
				// 		headers: {
				// 			"Access-Control-Allow-Origin": "*",
				// 			"Content-Type": "application/json"
				// 		}
				// 	});
				// } catch (error) {
				// 	console.log("error", error);
				// }

				window.open(`https://wonde.zendesk.com/access/jwt?jwt=${token}`, "_blank");
				window.Intercom("trackEvent", "visit-support");
				this.$vuedals.close(false);
			} catch (error) {
				this.$message.error("Failed to authenticate with Zendesk");
			}
			this.loading = false;
		},
		async getToken() {
			const response = await this.$apollo.query({
				query: gql`
					query ZendeskToken($company: ID!) {
						ZendeskToken(company: $company) {
							token
						}
					}
				`,
				variables: {
					company: this.companyId
				},
				fetchPolicy: "network-only"
			});
			return response.data.ZendeskToken.token;
		}
	},

	apollo: {
		companies: {
			query: UserCompaniesQuery,
			update(r) {
				let companies = r.User.Companies;
				this.companyId = companies[0].id;
				if (companies.length == 1) {
					this.visitZendesk();
				}
				return companies;
			}
		}
	}
};
</script>
